<template>
    <div>
        <section class="page-title" :style="`background-color: ${informacaoOperadora('corPrincipal')}`">
            <div class="center">
                <h1 class="the-title" style="color: white">Contato</h1>
                <p style="color: white">Dúvidas, críticas ou sugestões entre em contato conosco!</p>
            </div>
        </section>
        <div class="page-content center" style="text-align: center">
            <div class="row-contact">
                <v-flex xs12 sm12 md12 lg6>
                    <v-icon size="50" color="#0098DA">map</v-icon>
                    <p class="title" style="color: #666; margin-top: 10px"><strong>Localização</strong></p>
                    <p>R. das Bandeiras, 55 - 1° andar - Jardim - Santo André - SP - CEP: 09090-780</p>
                </v-flex>
                <v-flex xs12 sm12 md12 lg3>
                    <v-icon size="50" color="#0098DA">phone</v-icon>
                    <p class="title" style="color: #666; margin-top: 10px"><strong>Telefone</strong></p>
                    <p>(11) 4979-2200</p>
                </v-flex>
                <v-flex xs12 sm12 md12 lg3>
                    <v-icon size="50" color="#0098DA">phone</v-icon>
                    <p class="title" style="color: #666; margin-top: 10px"><strong>Central de Relacionamento</strong></p>
                    <p>(11) 97458-0480</p>
                </v-flex>
            </div>
            <v-btn href="https://wa.me/5511974580480?text=Ol%C3%A1,%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20dos%20Planos%20e%20de%20como%20contratar." target="_blank" large round color="success" dark>
                <v-icon left>chat</v-icon>
                Central de Relacionamento
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { operadora } from '@/global'
    export default {
        data() {
            return {

            }
        },
        
        mounted : function() {
            this.$store.dispatch('ExibeToolbar')
            this.$store.dispatch('Logar')
        },

        methods: {
            informacaoOperadora(atributo) {
                return operadora[atributo]
            },
        },
}
</script>

<style>

</style>
